import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface AuthState {
  token: any;
  email: any;
  setToken: (token: string) => void;
  clearToken: () => void;
  setEmail: (email: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: undefined,
      email: undefined,
      setToken: (token) => set({ token }),
      clearToken: () => set({ token: undefined }),
      setEmail: (email) => set({ email }),
    }),
    {
      name: "auth-token-sungga-manager",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
